import React, { useState, useContext } from 'react'
import { Button, Menu, MenuItem, Divider, Typography, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CurrencyContext, currencies } from '../currencyContext'
import { LandSizeUnitContext, units } from '../landSizeUnitContext'

export default function CurrencyIndicator(props) {
    const [anchor, setAnchor] = useState(null)
    const currency = useContext(CurrencyContext)
    const unit     = useContext(LandSizeUnitContext)
    const open     = Boolean(anchor)

    function handleClose(newCurrency, newUnit) {
        if (newCurrency?.name) currency.changeCurrency(newCurrency)
        if (newUnit?.name)     unit.changeUnit(newUnit)
        setAnchor(null)
    }

    return (
        <Box sx={props.style}>
            <Button
                onClick={e => setAnchor(e.currentTarget)}
                variant='outlined'
                size='small'
                endIcon={<ExpandMoreIcon sx={{ transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'none' }} />}
                sx={{
                    borderColor: 'divider',
                    color: 'text.primary',
                    fontWeight: 600,
                    fontSize: '0.78rem',
                    px: 1.5,
                    gap: 0.75,
                    whiteSpace: 'nowrap',
                    '&:hover': { borderColor: 'primary.main', color: 'primary.main', bgcolor: 'transparent' },
                }}
            >
                {currency.value.name}
                <Box component='span' sx={{ color: 'divider', userSelect: 'none' }}>|</Box>
                {unit.value.name}
            </Button>

            <Menu
                open={open}
                anchorEl={anchor}
                onClose={() => handleClose()}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ sx: { mt: 0.5, minWidth: 150, boxShadow: 3 } }}
            >
                <Typography variant='overline' sx={{ px: 2, py: 0.5, display: 'block', color: 'text.dimGrey' }}>
                    Currency
                </Typography>
                {currencies.map(c => (
                    <MenuItem
                        key={c.name}
                        selected={c.name === currency.value.name}
                        onClick={() => handleClose(c)}
                        dense
                    >
                        {c.name}
                    </MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <Typography variant='overline' sx={{ px: 2, py: 0.5, display: 'block', color: 'text.dimGrey' }}>
                    Area Unit
                </Typography>
                {units.map(u => (
                    <MenuItem
                        key={u.name}
                        selected={u.name === unit.value.name}
                        onClick={() => handleClose(null, u)}
                        dense
                    >
                        {u.name}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    )
}
